webpackJsonp([1],{

/***/ "IkKh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L/hj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["deepClone"] = deepClone;
/* harmony export (immutable) */ __webpack_exports__["getExtendibleLeaf"] = getExtendibleLeaf;
/* harmony export (immutable) */ __webpack_exports__["getChild"] = getChild;
/* harmony export (immutable) */ __webpack_exports__["initChild"] = initChild;
/* harmony export (immutable) */ __webpack_exports__["setVal"] = setVal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


function deepClone(obj) {
  return JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(obj));
}

function getExtendibleLeaf(obj, n, initIt) {
  var v = obj[n];
  if (v && (typeof v === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(v)) === 'object' && !Array.isArray(v)) {
    return v;
  }
  if (initIt && v === undefined) {
    return obj[n] = {};
  }
}

function getChild(data, ns) {
  if (ns.length === 1) {
    return data[ns[0]];
  }
  var obj = data[ns[0]];
  if (obj === undefined) return obj;
  var i = 1;
  var end = ns.length - 1;
  for (; i < end; i++) {
    obj = getExtendibleLeaf(obj, ns[i], false);
    if (obj === undefined) return obj;
  }
  return obj[ns[i]];
}

function initChild(data, ns) {
  if (ns.length === 1) {
    var ret = getExtendibleLeaf(data, ns[0], true);
    if (ret === undefined) {
      throw new TypeError('fail to init because namespace ' + ns[0] + ' = ' + data[ns[0]]);
    }
    return ret;
  }
  var parent = data;
  var obj = data[ns[0]];
  if (obj === undefined) obj = data[ns[0]] = {};
  for (var i = 1; i < ns.length; i++) {
    var n = ns[i];
    var _ret = getExtendibleLeaf(obj, n, true);
    if (_ret === undefined) {
      throw new TypeError('fail to init because namespace ' + ns.join('.') + ' = ' + obj + '(' + (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj)) + ')');
    }
    parent = obj;
    obj = _ret;
    if (parent[n] === undefined) {
      throw new TypeError('fail to init because namespace ' + ns.slice(0, i).join('.') + ' = ' + parent);
    }
  }
  return obj;
}

function setVal(data, n, v) {
  var ns = Array.isArray(n) ? n : n.split('.');
  // eslint-disable-next-line
  n = ns.pop();
  var ret = ns.length > 0 ? initChild(data, ns) : data;
  ret[n] = v;
  return v;
}

/***/ }),

/***/ "SrUm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./src/parser.js






var _require = __webpack_require__("L/hj"),
    initChild = _require.initChild,
    getChild = _require.getChild;

var ARRAY_KEYWORDS = ['anyOf', 'oneOf', 'enum'];

var setCommonFields = function setCommonFields(schema, field, schemaName) {
  // eslint-disable-next-line no-nested-ternary
  field.value = schema.hasOwnProperty('default') ? schema.default : field.hasOwnProperty('value') ? field.value : '';

  field.component = schema.component;
  field.schemaType = schema.type;
  field.label = schema.title || '';
  field.description = schema.description || '';
  field.required = schema.required || false;
  field.disabled = schema.disabled || false;
  field.name = schemaName;
};

var setFormValue = function setFormValue(vm, field) {
  var ns = field.name.split('.');
  var vmValue = getChild(vm.value, ns);
  if (vm.value && !vmValue) {
    var n = ns.pop();
    var ret = ns.length > 0 ? initChild(vm.value, ns) : vm.value;
    vm.$set(ret, n, field.value);
  }
};

var parseBoolean = function parseBoolean(vm, schema, schemaName) {
  var field = schema.attrs || {};

  setCommonFields(schema, field, schemaName);

  if (!field.type) {
    field.type = 'checkbox';
  }

  field.checked = schema.checked || false;

  if (schema.name) {
    field.name = schemaName;

    setFormValue(vm, field);
  }

  return field;
};

var parseString = function parseString(vm, schema, schemaName) {
  var field = schema.attrs || {};

  if (schema.format) {
    switch (schema.format) {
      case 'email':
        if (!field.type) {
          field.type = 'email';
        }
        break;
      case 'uri':
        if (!field.type) {
          field.type = 'url';
        }
        break;
      case 'regex':
        if (!field.type) {
          field.type = 'text';
        }

        field.pattern = schema.pattern;
        break;
    }
  }

  if (!field.type) {
    switch (schema.type) {
      case 'number':
      case 'integer':
        field.type = 'number';
        break;
      default:
        field.type = 'text';
    }
  }

  setCommonFields(schema, field, schemaName);

  if (schema.name) {
    field.name = schemaName;

    setFormValue(vm, field);
  }

  if (schema.minLength) {
    field.minlength = schema.minLength;
  }

  if (schema.maxLength) {
    field.maxlength = schema.maxLength;
  }

  return field;
};

var parser_parseItems = function parseItems(items) {
  return items.map(function (item) {
    if ((typeof item === 'undefined' ? 'undefined' : typeof_default()(item)) !== 'object') {
      return { value: item, label: item };
    }

    return item;
  });
};

var parser_parseArray = function parseArray(vm, schema, schemaName) {
  var field = schema.attrs || {};

  setCommonFields(schema, field, schemaName);

  field.multiple = schema.minItems > 1;
  field.items = [];

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = get_iterator_default()(ARRAY_KEYWORDS), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var keyword = _step.value;

      if (schema.hasOwnProperty(keyword)) {
        switch (keyword) {
          case 'enum':
            if (!field.type) {
              field.type = 'select';
            }
            field.value = field.value || '';
            field.items = parser_parseItems(schema[keyword]);
            break;

          case 'oneOf':
            field.type = 'radio';
            field.value = field.value || '';
            field.items = parser_parseItems(schema[keyword]);
            break;

          case 'anyOf':
            field.type = 'checkbox';
            field.value = field.value || [];
            field.items = parser_parseItems(schema[keyword]);
            break;
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (!field.type) {
    field.type = schema.type;
    field.value = field.value || [];
    field.items = [];
  }

  if (schema.name) {
    field.name = schemaName;

    setFormValue(vm, field);
  }

  return field;
};

var parser_loadFields = function loadFields(vm, schema) {
  var fields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : vm.fields;
  var sub = arguments[3];

  if (!schema || schema.visible === false) return;

  var schemaName = sub ? sub.join('.') : schema.name;

  switch (schema.type) {
    case 'object':
      for (var key in schema.properties) {
        schema.properties[key].name = key;

        if (schema.required) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = get_iterator_default()(schema.required), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var field = _step2.value;

              if (schema.properties[field]) {
                schema.properties[field].required = true;
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
        if (schema.name && !fields[schemaName]) {
          fields[schemaName] = {
            $sub: true,
            $title: schema.title,
            $description: schema.description
          };
        }
        loadFields(vm, schema.properties[key], schema.name ? fields[schemaName] : undefined, sub ? [].concat(toConsumableArray_default()(sub), [key]) : [key]);
      }
      break;

    case 'boolean':
      fields[schemaName] = parseBoolean(vm, schema, schemaName);
      break;

    case 'array':
      fields[schemaName] = parser_parseArray(vm, schema, schemaName);
      break;

    case 'integer':
    case 'number':
    case 'string':
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = get_iterator_default()(ARRAY_KEYWORDS), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var keyword = _step3.value;

          if (schema.hasOwnProperty(keyword)) {
            schema.items = {
              type: schema.type,
              enum: schema[keyword]
            };
            fields[schemaName] = parser_parseArray(vm, schema, schemaName);
            return;
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      fields[schemaName] = parseString(vm, schema, schemaName);
      break;
    default:
      fields[schemaName] = parseString(vm, schema, schemaName);
  }
};
// EXTERNAL MODULE: ./src/utils.js
var utils = __webpack_require__("L/hj");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/JsonEditor.vue







var JsonEditor_option = { native: true };
var components = {
  title: { component: 'h1', option: JsonEditor_option },
  description: { component: 'p', option: JsonEditor_option },
  error: { component: 'div', option: JsonEditor_option },
  form: { component: 'form', option: JsonEditor_option },
  file: { component: 'input', option: JsonEditor_option },
  label: { component: 'label', option: JsonEditor_option },
  input: { component: 'input', option: JsonEditor_option },
  radio: { component: 'input', option: JsonEditor_option },
  select: { component: 'select', option: JsonEditor_option },
  option: { component: 'option', option: JsonEditor_option },
  button: {
    component: 'button',
    option: extends_default()({}, JsonEditor_option, {
      type: 'submit',
      label: 'Submit'
    })
  },
  checkbox: { component: 'input', option: JsonEditor_option },
  textarea: { component: 'textarea', option: JsonEditor_option },
  radiogroup: { component: 'div', option: JsonEditor_option },
  checkboxgroup: { component: 'div', option: JsonEditor_option }
};
var defaultInput = { component: 'input', option: JsonEditor_option };
var defaultGroup = { component: 'div', option: JsonEditor_option };

/**
 * Edit JSON in UI form with JSON Schema and Vue.js `<json-editor>` component.
 *
 * @author Yourtion
 * @license MIT
 */
/* harmony default export */ var JsonEditor = ({
  name: 'JsonEditor',
  props: {
    /**
     * The JSON Schema object. Use the `v-if` directive to load asynchronous schema.
     */
    schema: { type: Object, required: true },
    /**
     * Use this directive to create two-way data bindings with the component. It automatically picks the correct way to update the element based on the input type.
     * @model
     * @default {}
     */
    value: { type: Object, default: function _default() {
        return {};
      } },
    /**
     * This property indicates whether the value of the control can be automatically completed by the browser. Possible values are: `off` and `on`.
     */
    autoComplete: { type: String },
    /**
     * This Boolean attribute indicates that the form is not to be validated when submitted.
     */
    noValidate: { type: Boolean },
    /**
     * Define the inputs wrapping class. Leave `undefined` to disable input wrapping.
     */
    inputWrappingClass: { type: String }
  },
  data: function data() {
    return {
      default: {},
      fields: {},
      error: null,
      data: {}
    };
  },
  created: function created() {
    parser_loadFields(this, Object(utils["deepClone"])(this.schema));
    this.default = Object(utils["deepClone"])(this.value);
    this.data = Object(utils["deepClone"])(this.value);
  },
  render: function render(createElement) {
    var _this3 = this;

    var nodes = [];
    if (this.schema.title) {
      nodes.push(createElement(components.title.component, this.schema.title));
    }
    if (this.schema.description) {
      nodes.push(createElement(components.description.component, this.schema.description));
    }
    if (this.error) {
      var errorOptions = this.elementOptions(components.error);
      var errorNodes = [];
      if (components.error.option.native) {
        errorNodes.push(this.error);
      }
      nodes.push(createElement(components.error.component, errorOptions, errorNodes));
    }
    var allFormNodes = [];
    var formNode = {
      root: {}
    };
    function createForm(fields, sub) {
      var _this = this;

      var node = void 0;
      if (sub) {
        node = Object(utils["setVal"])(formNode, sub.pop(), {});
      } else {
        node = formNode.root;
      }

      if (keys_default()(fields).length) {
        keys_default()(fields).forEach(function (key) {
          var formNodes = [];
          if (key.indexOf('$') === 0) return;
          var field = fields[key];
          if (field.$sub) {
            return createForm.call(_this, field, sub ? [].concat(toConsumableArray_default()(sub), [key]) : [key]);
          }
          var fieldName = field.name;

          var fieldValue = Object(utils["getChild"])(_this.value, fieldName.split('.'));
          if (!field.value) {
            field.value = fieldValue;
          }
          var customComponent = field.component ? { component: field.component, option: {} } : undefined;
          // eslint-disable-next-line
          var element = field.component ? customComponent : field.hasOwnProperty('items') && field.type !== 'select' ? components[field.type + 'group'] || defaultGroup : components[field.type] || defaultInput;
          var fieldOptions = _this.elementOptions(element, field, field);
          var children = [];

          var input = extends_default()({
            ref: fieldName,
            domProps: {
              value: fieldValue
            },
            on: {
              input: function input(event) {
                var value = event && event.target ? event.target.value : event;
                var ns = fieldName.split('.');
                var n = ns.pop();
                var ret = ns.length > 0 ? Object(utils["initChild"])(_this.data, ns) : _this.data;
                _this.$set(ret, n, value);
                /**
                 * Fired synchronously when the value of an element is changed.
                 */
                _this.$emit('input', _this.data);
              },
              change: _this.changed
            }
          }, fieldOptions);
          delete field.value;
          switch (field.type) {
            case 'textarea':
              if (element.option.native) {
                input.domProps.innerHTML = fieldValue;
              }
              break;
            case 'radio':
            case 'checkbox':
              if (field.hasOwnProperty('items')) {
                field.items.forEach(function (item) {
                  var itemOptions = _this.elementOptions(components[field.type], item, item, item);
                  children.push(createElement(components[field.type].component, itemOptions, item.label));
                });
              }
              break;
            case 'select':
              if (!field.required) {
                children.push(createElement(components.option.component));
              }
              field.items.forEach(function (option) {
                var optionOptions = _this.elementOptions(components.option, {
                  value: option.value
                }, field);
                children.push(createElement(components.option.component, extends_default()({
                  domProps: {
                    value: option.value
                  }
                }, optionOptions), option.label));
              });
              break;
          }
          var inputElement = createElement(element.component, input, children);

          var formControlsNodes = [];
          if (field.label && !JsonEditor_option.disableWrappingLabel) {
            var _labelOptions = _this.elementOptions(components.label, field, field);
            var labelNodes = [];
            if (components.label.option.native) {
              labelNodes.push(createElement('span', {
                attrs: {
                  'data-required-field': field.required ? 'true' : 'false'
                }
              }, field.label));
            }
            labelNodes.push(inputElement);
            if (field.description) {
              labelNodes.push(createElement('br'));
              labelNodes.push(createElement('small', field.description));
            }
            formControlsNodes.push(createElement(components.label.component, _labelOptions, labelNodes));
          } else {
            formControlsNodes.push(inputElement);
            if (field.description) {
              formControlsNodes.push(createElement('br'));
              formControlsNodes.push(createElement('small', field.description));
            }
          }
          if (_this.inputWrappingClass) {
            formNodes.push(createElement('div', {
              class: _this.inputWrappingClass
            }, formControlsNodes));
          } else {
            formControlsNodes.forEach(function (node) {
              return formNodes.push(node);
            });
          }
          node[key] = formNodes[0];
        });
      }
    }
    createForm.call(this, this.fields);

    function createNode(fields, sub) {
      var _this2 = this;

      var nodes = [];
      var subName = sub && sub.pop();
      if (fields.$title) {
        nodes.push(createElement('div', {
          class: 'sub-title'
        }, fields.$title));
      }
      keys_default()(fields).forEach(function (key) {
        if (key.indexOf('$') === 0) return;
        var field = fields[key];
        if (field.$sub) {
          var node = createNode.call(_this2, field, sub ? [].concat(toConsumableArray_default()(sub), [key]) : [key]);
          nodes.push(createElement('div', {
            class: 'sub'
          }, node));
        } else if (subName) {
          nodes.push(Object(utils["getChild"])(formNode, subName.split('.'))[key]);
        } else {
          nodes.push(formNode.root[key]);
        }
      });
      return nodes;
    }
    var formNodes = createNode.call(this, this.fields);
    allFormNodes.push(formNodes);

    var labelOptions = this.elementOptions(components.label);
    var button = this.$slots.hasOwnProperty('default') ? { component: this.$slots.default, option: JsonEditor_option } : components.button;
    if (button.component instanceof Array) {
      allFormNodes.push(createElement(components.label.component, labelOptions, button.component));
    } else {
      var buttonOptions = this.elementOptions(button);
      var buttonElement = createElement(button.component, buttonOptions, button.option.label);
      allFormNodes.push(createElement(components.label.component, labelOptions, [buttonElement]));
    }
    var formOptions = this.elementOptions(components.form, {
      autocomplete: this.autocomplete,
      novalidate: this.novalidate
    });
    nodes.push(createElement(components.form.component, extends_default()({
      ref: '__form',
      on: {
        submit: function submit(event) {
          event.stopPropagation();
          _this3.submit(event);
        },
        invalid: this.invalid
      }
    }, formOptions), allFormNodes));
    return createElement('div', nodes);
  },
  mounted: function mounted() {
    this.reset();
  },
  setComponent: function setComponent(type, component) {
    var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    components[type] = { component: component, option: option };
  },

  methods: {
    /**
     * @private
     */
    optionValue: function optionValue(field, target) {
      var item = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return typeof target === 'function' ? target({ vm: this, field: field, item: item }) : target;
    },

    /**
     * @private
     */
    elementOptions: function elementOptions(element) {
      var extendingOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var item = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      var attrName = element.option.native ? 'attrs' : 'props';
      var elementProps = typeof element.option === 'function' ? element.option : extends_default()({}, element.option, { native: undefined });
      var options = this.optionValue(field, elementProps, item);
      return defineProperty_default()({}, attrName, extends_default()({}, extendingOptions, options));
    },

    /**
     * @private
     */
    changed: function changed(e) {
      /**
       * Fired when a change to the element's value is committed by the user.
       */
      this.$emit('change', e);
    },

    /**
     * Get a form input reference
     */
    input: function input(name) {
      if (!this.$refs[name]) {
        throw new Error('Undefined input reference \'' + name + '\'');
      }
      return this.$refs[name][0];
    },

    /**
     * Get the form reference
     */
    form: function form() {
      return this.$refs.__form;
    },

    /**
     * Checks whether the form has any constraints and whether it satisfies them. If the form fails its constraints, the browser fires a cancelable `invalid` event at the element, and then returns false.
     */
    checkValidity: function checkValidity() {
      return this.$refs.__form.checkValidity();
    },

    /**
     * @private
     */
    invalid: function invalid(e) {
      /**
       * Fired when a submittable element has been checked and doesn't satisfy its constraints. The validity of submittable elements is checked before submitting their owner form, or after the `checkValidity()` of the element or its owner form is called.
       */
      this.$emit('invalid', e);
    },

    /**
     * Reset the value of all elements of the parent form.
     */
    reset: function reset() {
      for (var key in this.data) {
        var ns = key.split('.');
        var n = ns.pop();
        var ret = ns.length > 0 ? Object(utils["initChild"])(this.data, ns) : this.data;
        var value = Object(utils["getChild"])(this.default, key.split('.'));
        this.$set(ret, n, value);
      }
    },

    /**
     * Send the content of the form to the server
     */
    submit: function submit(event) {
      if (this.checkValidity()) {
        /**
         * Fired when a form is submitted
         */
        this.$emit('submit', event);
      }
    },

    /**
     * Set a message error.
     */
    setErrorMessage: function setErrorMessage(message) {
      this.error = message;
    },

    /**
     * clear the message error.
     */
    clearErrorMessage: function clearErrorMessage() {
      this.error = null;
    }
  }
});
// CONCATENATED MODULE: ./src/JsonEditor.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  JsonEditor,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_JsonEditor = (Component.exports);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("zL8q");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./example/components/Subscription.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




src_JsonEditor.setComponent('form', 'el-form', function (_ref) {
  var vm = _ref.vm;

  // vm is the JsonEditor VM

  var labelWidth = '120px';
  var model = vm.data;
  var rules = {};

  function parseField(fields) {
    keys_default()(fields).forEach(function (key) {
      if (key.indexOf('$') === 0 && key !== '$sub') return;
      var field = fields[key];
      if (field.$sub) {
        return parseField(field);
      }
      if (!field.name) return;
      rules[field.name] = [];
      // http://element.eleme.io/#/en-US/component/form#validation
      var type = field.schemaType === 'array' && field.type === 'radio' ? 'string' : field.schemaType;
      var required = field.required;
      var message = field.title;
      var trigger = ['radio', 'checkbox', 'select'].includes(field.type) ? 'change' : 'blur';
      rules[field.name].push({ type: type, required: required, message: message, trigger: trigger });

      if (field.minlength !== undefined || field.maxlength !== undefined) {
        var max = field.maxlength || 255;
        var min = field.minlength || 0;
        var msg = 'Length must between ' + min + ' and ' + max;
        rules[field.name].push({ min: min, max: max, message: msg, trigger: trigger });
      }
    });
  }

  parseField(vm.fields);

  // returning the form props
  return { labelWidth: labelWidth, rules: rules, model: model };
});

// http://element.eleme.io/#/en-US/component/form#validation
src_JsonEditor.setComponent('label', 'el-form-item', function (_ref2) {
  var field = _ref2.field;
  return {
    prop: field.name
  };
});

src_JsonEditor.setComponent('email', 'el-input');
src_JsonEditor.setComponent('url', 'el-input');
src_JsonEditor.setComponent('number', 'el-input-number');
src_JsonEditor.setComponent('text', 'el-input');
src_JsonEditor.setComponent('textarea', 'el-input');
src_JsonEditor.setComponent('checkbox', 'el-checkbox');
src_JsonEditor.setComponent('checkboxgroup', 'el-checkbox-group');
src_JsonEditor.setComponent('radio', 'el-radio');
src_JsonEditor.setComponent('select', 'el-select');
src_JsonEditor.setComponent('switch', 'el-switch');
src_JsonEditor.setComponent('color', 'el-color-picker');
src_JsonEditor.setComponent('rate', 'el-rate');

// You can also use the component object
src_JsonEditor.setComponent('option', element_ui_common["Option"]);

// By default `<h1/>` is used to render the form title.
// To override this, use the `title` type:
src_JsonEditor.setComponent('title', 'h2');

// By default `<p/>` is used to render the form title.
// To override this, use the `description` type:
src_JsonEditor.setComponent('description', 'small');

// By default `<div/>` is used to render the message error.
// To override this, use the `error` type:
src_JsonEditor.setComponent('error', 'el-alert', function (_ref3) {
  var vm = _ref3.vm;
  return {
    type: 'error',
    title: vm.error
  };
});

/* harmony default export */ var Subscription = ({
  data: function data() {
    return {
      schema: __webpack_require__("x9Nm"),
      model: {
        name: 'Yourtion',
        sub: {
          sEmail: 'yourtion@gmail.com'
        }
      }
    };
  },
  computed: {
    jsonString: function jsonString() {
      return stringify_default()(this.model, null, 2).trim();
    }
  },
  methods: {
    submit: function submit(_e) {
      var _this = this;

      this.$refs.JsonEditor.form().validate(function (valid) {
        if (valid) {
          // this.model contains the valid data according your JSON Schema.
          // You can submit your model to the server here

          // eslint-disable-next-line no-console
          console.log('model', stringify_default()(_this.model));
          _this.$refs.JsonEditor.clearErrorMessage();
        } else {
          _this.$refs.JsonEditor.setErrorMessage('Please fill out the required fields');
          return false;
        }
      });
    },
    reset: function reset() {
      this.$refs.JsonEditor.reset();
    }
  },
  components: { JsonEditor: src_JsonEditor }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f8bc92b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/components/Subscription.vue
var Subscription_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-card',{staticClass:"form"},[_c('json-editor',{ref:"JsonEditor",attrs:{"schema":_vm.schema},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.submit}},[_vm._v("Subscribe")]),_vm._v(" "),_c('el-button',{attrs:{"type":"reset"},on:{"click":_vm.reset}},[_vm._v("Reset")])],1)],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Model")])]),_vm._v(" "),_c('pre',{staticClass:"json"},[_vm._v(_vm._s(_vm.jsonString))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("How to use")])]),_vm._v(" "),_c('div',{staticClass:"json"},[_c('p',[_vm._v("GitHub: "),_c('a',{attrs:{"href":"https://github.com/yourtion/vue-json-ui-editor","target":"_blank"}},[_vm._v("vue-json-ui-editor")])]),_vm._v(" "),_c('p',[_vm._v("NPM: "),_c('a',{attrs:{"href":"https://www.npmjs.com/package/vue-json-ui-editor","target":"_blank"}},[_vm._v("json-editor")])])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: Subscription_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Subscription = (esExports);
// CONCATENATED MODULE: ./example/components/Subscription.vue
function injectStyle (ssrContext) {
  __webpack_require__("IkKh")
}
var Subscription_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Subscription___vue_template_functional__ = false
/* styles */
var Subscription___vue_styles__ = injectStyle
/* scopeId */
var Subscription___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Subscription___vue_module_identifier__ = null
var Subscription_Component = Subscription_normalizeComponent(
  Subscription,
  components_Subscription,
  Subscription___vue_template_functional__,
  Subscription___vue_styles__,
  Subscription___vue_scopeId__,
  Subscription___vue_module_identifier__
)

/* harmony default export */ var example_components_Subscription = (Subscription_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./example/App.vue
//
//
//
//
//
//



/* harmony default export */ var App = ({
  name: 'app',
  components: {
    Subscription: example_components_Subscription
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d4d3de3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Subscription')],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_example_App = (App_esExports);
// CONCATENATED MODULE: ./example/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("sHr2")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_example_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var example_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/theme-chalk/index.css
var theme_chalk = __webpack_require__("tvR6");
var theme_chalk_default = /*#__PURE__*/__webpack_require__.n(theme_chalk);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/locale/lang/en.js
var en = __webpack_require__("wUZ8");
var en_default = /*#__PURE__*/__webpack_require__.n(en);

// CONCATENATED MODULE: ./example/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







vue_esm["default"].use(element_ui_common_default.a, { locale: en_default.a });

vue_esm["default"].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["default"]({
  el: '#app',
  template: '<App/>',
  components: { App: example_App },
});


/***/ }),

/***/ "sHr2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x9Nm":
/***/ (function(module, exports) {

module.exports = {"$schema":"http://json-schema.org/draft-07/schema#","type":"object","title":"Json-Editor-Demo","description":"Demo for vue-json-ui-editor using element-ui ","properties":{"name":{"type":"string","minLength":8,"maxLength":80,"title":"String","attrs":{"placeholder":"Your Full Name","title":"Please enter your full name"}},"sub":{"title":"SubTitle","description":"SubDescription","type":"object","properties":{"sName":{"minLength":8,"maxLength":80,"title":"SubName","attrs":{"placeholder":"Sub Full Name","title":"Please enter your full name"}},"sUrl":{"title":"SubUrl","format":"uri"},"sub2":{"type":"object","title":"Sub2Title","description":"Sub2Description","properties":{"sName2":{"format":"regex","title":"Sub2Name","pattern":"*"},"sAge":{"type":"integer","title":"Sub2Age"}},"required":["sName2"]}},"required":["sUrl"]},"lists":{"type":"string","title":"List","enum":["Daily New","Promotion"],"attrs":{"placeholder":"Select your list subscription","title":"Please select your list subscription"}},"lists2":{"type":"array","title":"List2","anyOf":[{"value":"daily","label":"Daily New"},{"value":"promotion","label":"Promotion"}],"attrs":{"placeholder":"Select your list subscription","title":"Please select your list subscription"}},"lists3":{"type":"array","title":"List3","oneOf":[{"value":"daily","label":"Daily New"},{"value":"promotion","label":"Promotion"}]},"source":{"type":"string","maxLength":120,"title":"Source","description":"Ex. Using the NPM Search Engine","attrs":{"type":"textarea","placeholder":"How did you hear about us?"}},"rate":{"type":"number","title":"Rate","default":2,"attrs":{"type":"rate","allow-half":true}},"color":{"type":"string","title":"Color","default":"#409EFF","attrs":{"type":"color"}},"agree":{"type":"boolean","title":"Agree","description":"You agree to receive occasional updates and special offers for vue-json-schema updates.","default":false,"attrs":{"type":"switch"}}},"additionalProperties":false,"required":["name","email","lists"]}

/***/ })

},["SrUm"]);


// WEBPACK FOOTER //
// static/js/app.6929d2b6ad0b23e9ecf4.js